window.ProductHeaderHelper = (productSelector) => {
  const originalHeader = document.querySelector(
    `${productSelector} .product__header`
  );
  let duplicateHeader = document.createElement('div');
  duplicateHeader.classList =
    'product__header-mobile hide smaller-lap--show-block';
  duplicateHeader.innerHTML = document.querySelector(
    `${productSelector} product-header`
  ).innerHTML;
  duplicateHeader.querySelector('.product__price').id = '';
  document.querySelector(`${productSelector}`).prepend(duplicateHeader);
  duplicateHeader = duplicateHeader.querySelector('.product__header');
  const headerObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      duplicateHeader.innerHTML = originalHeader.innerHTML;
    }
  });
  headerObserver.observe(originalHeader, {
    attributes: false,
    childList: true,
    subtree: true,
  });
};
